import { FC } from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import { IconProps } from "design-system/domain/components";

const Close: FC<IconProps> = ({ className }) => (
  <CloseIcon className={className} />
);

export default Close;